<template lang="pug">
  d-input-base(
    :component="VInput"
    v-bind="extendAttrs"
    v-on="$listeners"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
import DInputBase from './DInputBase.vue';
import { VInput } from 'vuetify/lib';

export default {
  components:  { DInputBase, VInput },
  data() {
    return {
      VInput,
    };
  },
  computed: {
    extendAttrs() {
      return {
        ...this.$attrs,
      };
    },
  },
};
</script>
